import { render, staticRenderFns } from "./tableComponent.vue?vue&type=template&id=6a022213"
import script from "./tableComponent.vue?vue&type=script&lang=js"
export * from "./tableComponent.vue?vue&type=script&lang=js"
import style0 from "./tableComponent.vue?vue&type=style&index=0&id=6a022213&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports